module.exports = __webpack_public_path__ + "img/logo_bottom.5794335f.png";